import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {RootState} from "../../app/store";



export interface PostState {
    post?: boolean;

}

const initialState: PostState = {

};


export const postSlice = createSlice({
    name: 'post',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setPost: (state, action: PayloadAction<any>) => {
            state.post = action.payload;
        }
    },
});

export const {
    setPost

} = postSlice.actions;




export const selectPost = (state: RootState) => state.post.post;



export default postSlice.reducer;
